module.exports = __webpack_public_path__ + "media/images/landing_page/circular_lock_icon-c02cc42776b4bee7e5b9f4210d583c69.png";